import React from 'react';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import AppLink from 'components/content/shared/links/AppLink';
import { orderPageRoutes, IRoute, deliveriesPageRoutes } from 'components/navigation/routes';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { useHistory } from 'react-router-dom';

interface IProps
{
	invoiceId: number,
	invoice: any,
}

export function InvoiceDetailLinks(props: IProps)
{
	
	console.log(props)
	
	const history = useHistory();
	
	function onRelatedOrdersClick()
	{
		const orderId = props.invoice.orderId
		const orderRoute = orderPageRoutes.find(r => r.routeId === RouteId.orderDetail) as IRoute;
		let path = orderRoute.path + '?id=' + orderId;
		history.push(path);
	}
	
	function onRelatedInvoicesClick()
	{
		const deliveryId = props.invoice.deliveryId
		const deliveryRoute = deliveriesPageRoutes.find(r => r.routeId === RouteId.deliveryDetail) as IRoute;
		let path = deliveryRoute.path + '?id=' + deliveryId;
		history.push(path);
	}


	return (
		<>
			<ContainerSectionTitle>Links</ContainerSectionTitle>
			<div>
				<AppLink className="mgr-35 pdy-5" onClick={onRelatedOrdersClick} href="">
					Related Order
				</AppLink>
				<AppLink className="mgr-35 pdy-5" onClick={onRelatedInvoicesClick} href="">
					Related Delivery
				</AppLink>
			</div>
		</>
	);
};